import {css, Icon, view} from '@sail/ui/deprecated';
import {cancel} from '@sail/icons/react/Icon';
import {defineMessages, useIntl} from 'react-intl';
import {useTheme} from '@stripe-internal/conversations-ui';

const messages = defineMessages({
  buttonText: {
    id: 'support_conversations_client.form.closeButton.buttonText',
    description: 'Aria label for the button to dismiss certain forms',
    defaultMessage: 'Close',
  },
});

type Props = {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  dataTestId?: string;
};

export const CloseButton = ({onClick, dataTestId}: Props) => {
  const intl = useIntl();
  const theme = useTheme();

  return (
    <view.button
      css={{
        display: css.value('flex'),
        position: css.value('absolute'),
        borderRadius: 'small',
        borderStyle: css.value('none'),
        color: 'secondary',
        backgroundColor: 'surface',
        top: 0,
        right: 0,
        padding: 'xsmall',
        bleedTop: 'xsmall',
        bleedRight: 'xsmall',
      }}
      aria-label={intl.formatMessage(messages.buttonText)}
      onClick={onClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = String(
          css.value('$color.neutral100'),
        );
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = '';
      }}
      onFocus={(e) => {
        e.currentTarget.style.outline = String(theme.focusVisibleOutline || '');
      }}
      onBlur={(e) => {
        e.currentTarget.style.outline = '';
      }}
      type="button"
      data-testid={dataTestId}
    >
      <Icon icon={cancel} size="small" data-testid="close-icon" />
    </view.button>
  );
};
